import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { Text } from '@jisr-hr/design-system'

import Signpost from '../../../ds/Signpost'

import Styles from '../Info.module.css'

const RequestedBy = ({ name, jobtitle }) => (
  <Signpost>
    <Text
      typography="caption12"
      color="var(--color-natural-black-default-new)"
      as="span"
    >
      {I18n.t('requested_by')}{' '}
      <span className={Styles.requestedBy}>
        {name} {jobtitle && `(${jobtitle})`}
      </span>
    </Text>
  </Signpost>
)

RequestedBy.propTypes = {
  name: PropTypes.string,
  jobtitle: PropTypes.string,
}

export default RequestedBy
